/**
 * @fileoverview CAVE API endpoint URL builders.
 *
 * Constructs properly encoded URLs for all CAVE API operations (intake, status,
 * output, download). Encodes path and query parameters to handle edge cases
 * (spaces, special characters, etc.).
 */

import environment from 'platform/utilities/environment';

const BASE_URL = `${environment.API_URL}/v0/cave`;

const encodeIdSegment = id => encodeURIComponent(id);

/**
 * Builds the URL for document intake (upload).
 * @returns {string} The intake endpoint URL
 */
export const buildIntakeUrl = () => BASE_URL;

/**
 * Builds the URL for polling document processing status.
 * @param {string} id - The document ID
 * @returns {string} The status polling endpoint URL
 */
export const buildStatusUrl = id => `${BASE_URL}/${encodeIdSegment(id)}/status`;

/**
 * Builds the URL for fetching the artifact summary (list of forms extracted).
 * @param {string} id - The document ID
 * @param {string} [type='artifact'] - The output type (e.g., 'artifact')
 * @returns {string} The output/summary endpoint URL
 */
export const buildOutputUrl = (id, type = 'artifact') =>
  `${BASE_URL}/${encodeIdSegment(id)}/output?type=${encodeURIComponent(type)}`;

/**
 * Builds the URL for downloading artifact data (extracted form content).
 * @param {string} id - The document ID
 * @param {string} kvpId - The artifact validation ID
 * @returns {string} The download endpoint URL
 */
export const buildDownloadUrl = (id, kvpId) =>
  `${BASE_URL}/${encodeIdSegment(id)}/download?kvpid=${encodeURIComponent(
    kvpId,
  )}`;
